var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ContainerPainel from '../../../components/container_painel';
import { BotaoAuxiliar, BotaoEditar, BotaoSalvar } from '../../../components/botoes';
import { BoxBotoes, BoxPrincipal } from '../../../components/form_box';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { MODOS } from '../../../utils';
import { alterarTipoUnidadePrisional, cadastrarTipoUnidadePrisional, getTipoUnidadePrisional } from './tipos_unidades_prisionais.service';
var MENSAGEM_DUPLICADO = 'Já existe um tipo de unidade prisional cadastrado com este nome.';
var MENSAGEM_ERRO_CADASTRO = 'No momento não foi possível realizar o cadastro do tipo de unidade prisional. Tente novamente mais tarde.';
var MENSAGEM_ERRO_EDICAO = 'No momento não foi possível salvar as alterações do tipo de unidade prisional. Tente novamente mais tarde.';
var MENSAGEM_FALHA_CARREGAMENTO = 'Não foi possível carregar os dados do registro. Tente novamente.';
var formatarDataHora = function (data) {
    return data
        ? new Date(data).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        })
        : '';
};
var formatarResponsavelEData = function (responsavel, data) {
    return [responsavel, formatarDataHora(data)].filter(Boolean).join(' — ') || '-';
};
export var TiposUnidadesPrisionaisAlterar = function () {
    var _a = useParams(), id = _a.id, modo = _a.modo;
    var idRegistro = id && id !== MODOS.CADASTRAR ? id : undefined;
    var _b = useState(''), nome = _b[0], setNome = _b[1];
    var _c = useState(null), registro = _c[0], setRegistro = _c[1];
    var _d = useState(''), erroNome = _d[0], setErroNome = _d[1];
    var _e = useState(null), modalAberto = _e[0], setModalAberto = _e[1];
    var _f = useState(null), tipoSucesso = _f[0], setTipoSucesso = _f[1];
    var _g = useState(false), salvando = _g[0], setSalvando = _g[1];
    var _h = useState(Boolean(idRegistro)), carregando = _h[0], setCarregando = _h[1];
    var _j = useState(false), falhaCarregamento = _j[0], setFalhaCarregamento = _j[1];
    var navigate = useNavigate();
    var location = useLocation();
    var _k = useAuth(), auth = _k.auth, getAcoesFuncionalidade = _k.getAcoesFuncionalidade;
    var acoes = getAcoesFuncionalidade(FUNCIONALIDADES.TIPOS_UNIDADES_PRISIONAIS);
    var modoFormulario = modo !== null && modo !== void 0 ? modo : MODOS.CADASTRAR;
    var estaEditando = modoFormulario === MODOS.ALTERAR;
    var estaVisualizando = modoFormulario === MODOS.VISUALIZAR;
    var somenteLeitura = estaVisualizando;
    useEffect(function () {
        auth(null, FUNCIONALIDADES.TIPOS_UNIDADES_PRISIONAIS, modoFormulario);
    }, [auth, modoFormulario]);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resposta, dados, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!idRegistro) {
                        setCarregando(false);
                        return [2 /*return*/];
                    }
                    setCarregando(true);
                    setFalhaCarregamento(false);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getTipoUnidadePrisional(idRegistro, estaEditando)];
                case 2:
                    resposta = _b.sent();
                    if ((resposta === null || resposta === void 0 ? void 0 : resposta.Status) === 'ERRO') {
                        if (resposta.httpStatus === 401) {
                            navigate(ROUTES.LOGOUT);
                            return [2 /*return*/];
                        }
                        if (resposta.httpStatus === 403) {
                            navigate(ROUTES.SEM_PERMISSAO);
                            return [2 /*return*/];
                        }
                        setFalhaCarregamento(true);
                        return [2 /*return*/];
                    }
                    dados = resposta;
                    if (!dados || typeof dados.nome !== 'string') {
                        setFalhaCarregamento(true);
                        return [2 /*return*/];
                    }
                    setRegistro(dados);
                    setNome(dados.nome);
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    setFalhaCarregamento(true);
                    return [3 /*break*/, 5];
                case 4:
                    setCarregando(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        void carregarDados();
        // Load the record when the route id or mode changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idRegistro, modo]);
    useEffect(function () {
        var _a;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.edicaoConcluida) {
            setTipoSucesso('edicao');
            setModalAberto('sucesso');
            navigate(location.pathname, { replace: true, state: null });
        }
    }, [location.pathname, location.state, navigate]);
    var salvar = function () { return __awaiter(void 0, void 0, void 0, function () {
        var nomeNormalizado, resposta, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    nomeNormalizado = nome.trim();
                    if (!nomeNormalizado) {
                        setErroNome('Campo obrigatório.');
                        return [2 /*return*/];
                    }
                    if (nomeNormalizado.length > 100) {
                        setErroNome('O nome deve possuir no máximo 100 caracteres.');
                        return [2 /*return*/];
                    }
                    setErroNome('');
                    setSalvando(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, 7, 8]);
                    if (!(estaEditando && idRegistro)) return [3 /*break*/, 3];
                    return [4 /*yield*/, alterarTipoUnidadePrisional(idRegistro, { nome: nomeNormalizado })];
                case 2:
                    _a = _c.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, cadastrarTipoUnidadePrisional({ nome: nomeNormalizado })];
                case 4:
                    _a = _c.sent();
                    _c.label = 5;
                case 5:
                    resposta = _a;
                    if (resposta.Status === 'OK') {
                        if (estaEditando && idRegistro) {
                            navigate("".concat(ROUTES.TIPOS_UNIDADES_PRISIONAIS, "/").concat(idRegistro, "/").concat(MODOS.VISUALIZAR), { state: { edicaoConcluida: true } });
                        }
                        else {
                            setTipoSucesso('cadastro');
                            setModalAberto('sucesso');
                        }
                        return [2 /*return*/];
                    }
                    if (resposta.httpStatus === 401) {
                        navigate(ROUTES.LOGOUT);
                        return [2 /*return*/];
                    }
                    if (resposta.httpStatus === 403) {
                        navigate(ROUTES.SEM_PERMISSAO);
                        return [2 /*return*/];
                    }
                    if (resposta.Mensagem === MENSAGEM_DUPLICADO) {
                        setErroNome(MENSAGEM_DUPLICADO);
                        return [2 /*return*/];
                    }
                    setModalAberto('erro');
                    return [3 /*break*/, 8];
                case 6:
                    _b = _c.sent();
                    setModalAberto('erro');
                    return [3 /*break*/, 8];
                case 7:
                    setSalvando(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var fecharModal = function () {
        if (modalAberto === 'sucesso') {
            setModalAberto(null);
            setTipoSucesso(null);
            if (!idRegistro) {
                navigate(ROUTES.TIPOS_UNIDADES_PRISIONAIS);
            }
            return;
        }
        setModalAberto(null);
    };
    var solicitarSaida = function () {
        setModalAberto('cancelamento');
    };
    var confirmarSaida = function () {
        if (estaEditando && idRegistro) {
            navigate("".concat(ROUTES.TIPOS_UNIDADES_PRISIONAIS, "/").concat(idRegistro, "/").concat(MODOS.VISUALIZAR));
            return;
        }
        navigate(ROUTES.TIPOS_UNIDADES_PRISIONAIS);
    };
    if (falhaCarregamento) {
        return (_jsxs(ContainerPainel, __assign({ pagina_acima: PAGINAS.TIPOS_UNIDADES_PRISIONAIS, pagina_especifica_permissao: FUNCIONALIDADES.TIPOS_UNIDADES_PRISIONAIS, link_pagina_acima: ROUTES.TIPOS_UNIDADES_PRISIONAIS, modo: modoFormulario, onNavegar: estaEditando ? solicitarSaida : undefined }, { children: [_jsxs(Box, __assign({ sx: { minHeight: 220, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1.5 } }, { children: [_jsx(WarningAmberIcon, { color: 'warning', fontSize: 'large' }), _jsx(Typography, { children: MENSAGEM_FALHA_CARREGAMENTO }), _jsx(Button, __assign({ variant: 'outlined', onClick: function () { return void carregarDados(); } }, { children: "Recarregar" }))] })), _jsxs(Dialog, __assign({ open: modalAberto === 'cancelamento', onClose: function () { return setModalAberto(null); }, fullWidth: true, maxWidth: 'sm' }, { children: [_jsx(DialogTitle, { children: "Deseja cancelar a edi\u00E7\u00E3o?" }), _jsx(DialogContent, { children: "As altera\u00E7\u00F5es realizadas ser\u00E3o perdidas." }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return setModalAberto(null); }, color: 'secondary' }, { children: "Voltar" })), _jsx(Button, __assign({ onClick: confirmarSaida, variant: 'contained', color: 'success' }, { children: "Confirmar" }))] })] }))] })));
    }
    if (carregando) {
        return (_jsx(ContainerPainel, __assign({ pagina_acima: PAGINAS.TIPOS_UNIDADES_PRISIONAIS, pagina_especifica_permissao: FUNCIONALIDADES.TIPOS_UNIDADES_PRISIONAIS, link_pagina_acima: ROUTES.TIPOS_UNIDADES_PRISIONAIS, modo: modoFormulario, onNavegar: estaEditando ? solicitarSaida : undefined }, { children: _jsx(BoxPrincipal, __assign({ sx: { minHeight: 180, alignItems: 'center', justifyContent: 'center' } }, { children: _jsx(CircularProgress, { size: 28 }) })) })));
    }
    return (_jsx(ContainerPainel, __assign({ pagina_acima: PAGINAS.TIPOS_UNIDADES_PRISIONAIS, pagina_especifica_permissao: FUNCIONALIDADES.TIPOS_UNIDADES_PRISIONAIS, link_pagina_acima: ROUTES.TIPOS_UNIDADES_PRISIONAIS, modo: modoFormulario, onNavegar: estaEditando || !idRegistro ? solicitarSaida : undefined }, { children: _jsxs(BoxPrincipal, { children: [_jsx(TextField, { id: 'nome-tipo-unidade-prisional', label: 'Nome', value: nome, onChange: function (event) {
                        setNome(event.target.value);
                        if (erroNome)
                            setErroNome('');
                    }, error: Boolean(erroNome), helperText: erroNome || ' ', required: true, fullWidth: true, inputProps: { maxLength: 100 }, disabled: salvando || carregando || somenteLeitura }), estaVisualizando && registro && (_jsxs(Box, __assign({ sx: { mt: 1, display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 1.5, width: '100%' } }, { children: [_jsx(TextField, { label: 'Cadastrado por / em', value: formatarResponsavelEData(registro.usuario_nome, registro.created_at), disabled: true, fullWidth: true }), _jsx(TextField, { label: '\u00DAltima altera\u00E7\u00E3o por / em', value: formatarResponsavelEData(registro.updated_by_nome, registro.updated_at), disabled: true, fullWidth: true })] }))), _jsxs(BoxBotoes, { children: [(estaEditando || !id) && _jsx(BotaoSalvar, { onClick: function () { return void salvar(); }, disabled: salvando || carregando }), estaVisualizando && (_jsx(BotaoEditar, { onClick: function () { return navigate("".concat(ROUTES.TIPOS_UNIDADES_PRISIONAIS, "/").concat(idRegistro, "/").concat(MODOS.ALTERAR)); }, disabled: !acoes.ALTERAR })), _jsx(BotaoAuxiliar, __assign({ backgroundColor: 'secondary.main', onClick: estaEditando || !idRegistro ? solicitarSaida : function () { return navigate(ROUTES.TIPOS_UNIDADES_PRISIONAIS); }, disabled: salvando }, { children: "Voltar" }))] }), _jsxs(Dialog, __assign({ open: modalAberto === 'cancelamento', onClose: function () { return setModalAberto(null); }, fullWidth: true, maxWidth: 'sm' }, { children: [_jsxs(DialogTitle, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(WarningAmberIcon, { color: 'warning' }), " ", estaEditando ? 'Deseja cancelar a edição?' : 'Deseja cancelar o cadastro?'] })), _jsx(DialogContent, { children: estaEditando ? 'As alterações realizadas serão perdidas.' : 'Os dados preenchidos serão perdidos.' }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return setModalAberto(null); }, color: 'secondary' }, { children: "Voltar" })), _jsx(Button, __assign({ onClick: confirmarSaida, variant: 'contained', color: 'success' }, { children: "Confirmar" }))] })] })), _jsxs(Dialog, __assign({ open: modalAberto === 'sucesso', onClose: fecharModal, fullWidth: true, maxWidth: 'sm' }, { children: [_jsxs(DialogTitle, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(CheckCircleIcon, { color: 'success' }), " ", tipoSucesso === 'edicao' ? 'Edição realizada' : 'Cadastro realizado'] })), _jsx(DialogContent, { children: tipoSucesso === 'edicao' ? 'Alterações salvas com sucesso.' : 'Tipo de unidade prisional cadastrado com sucesso.' }), _jsx(DialogActions, { children: _jsx(Button, __assign({ onClick: fecharModal, variant: 'contained', color: 'success' }, { children: "OK" })) })] })), _jsxs(Dialog, __assign({ open: modalAberto === 'erro', onClose: function () { return setModalAberto(null); }, fullWidth: true, maxWidth: 'sm' }, { children: [_jsxs(DialogTitle, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(ErrorIcon, { color: 'error' }), " ", estaEditando ? 'Não foi possível realizar a Edição' : 'Não foi possível realizar o Cadastro'] })), _jsx(DialogContent, { children: estaEditando ? MENSAGEM_ERRO_EDICAO : MENSAGEM_ERRO_CADASTRO }), _jsx(DialogActions, { children: _jsx(Button, __assign({ onClick: function () { return setModalAberto(null); }, variant: 'contained', color: 'warning' }, { children: "Voltar" })) })] }))] }) })));
};
export default TiposUnidadesPrisionaisAlterar;
